<script>
import { Auth } from 'portalba360';
import appConfig from "@/app.config";
import Layout from "../../layouts/auth";
import modal from '../../../components/modal-notificacion';

export default {
  data() {
    return {
      identificador: "",
      email: "",
      busy: false,
      mensajeModal: "",
      errorModal: false,
      error: false,
    };
  },
  page: {
    title: "Recuperar Contraseña",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout, 
    modal
  },
  methods: {
    async recPass (){
      if (!this.identificador || !this.email) {
        this.mensajeModal = "Necesita completar todos los campos"
        this.errorModal = true;
        this.error = true;
        return false;
      }
      let data = {
        company: process.env.VUE_APP_COMPANY,
        url: process.env.VUE_APP_API_URL,
        user: this.identificador,
        email: this.email
      }
      const auth = new Auth();
      try {
        const resp = await auth.recovery(data);
        resp.mensaje = "Recuperación de contraseña correcta. Redirigiendo...";
        this.mensajeModal = resp.mensaje;
        this.errorModal = false;
        this.error = true;
        setTimeout(()=>{ this.$router.push('./login') }, 5000)
      } catch (err) {
        this.mensajeModal = "No se pudo enviar el email de recuperación. Redirigiendo..."
        this.errorModal = true;
        this.error = true;
        setTimeout(()=>{ this.$router.push('./login') }, 5000)
      }
    },
    volver() {
      this.error = false;
      this.$router.push('./login');
    }
  }
};
</script>

<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-lg-5 col-md-7">
        <div class="card bg-secondary shadow border-0">
          <div class="col-lg-5 col-md-2">
            <router-link tag="a" to="/" class="btnVolver">↵&nbsp;Regresar</router-link>
          </div>
          <div class="card-body px-lg-5 py-lg-5">
            <div class="card overflow-hidden">
              <div class="bg-soft-primary">
                <div> 
                  <div class="header-back row">
                    <div class="col-12 mb-2">
                      <div class="text-header p-4 justify-content-center">
                        <h5 class="text-header">Recuperar contraseña</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-body pt-0">
                <div>
                  <router-link tag="a" to="/">
                    <div class="profile-user-wid mb-4">
                      <span class="logo-back avatar-title">
                        <img
                          src="@/assets/images/Logo_Mitta_Black.png"
                          alt
                          height="34"
                        />
                      </span>
                    </div>
                  </router-link>
                </div>

                <form role="form">
                  <b-form-group
                    id="input-group-1"
                    label="RUT | Identificador | DNI"
                    label-for="input-1"
                  >
                    <b-form-input
                      id="input-1"
                      class="input-group-alternative mb-3"
                      placeholder="ej: 12345678-9"
                      addon-left-icon="ni ni-email-83"
                      v-model="identificador"
                      v-on:keyup.enter="recuperar"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group
                    id="input-group-2"
                    label="Email"
                    label-for="input-2"
                  >
                    <b-form-input
                      id="input-2"
                      class="input-group-alternative"
                      placeholder="ej: email@email.com"
                      addon-left-icon="ni ni-lock-circle-open"
                      v-model="email"
                      v-on:keyup.enter="recuperar"
                    >
                    </b-form-input>
                  </b-form-group>                  
                  
                  <div class="mt-3">
                    <b-button
                      variant="danger"
                      class="btn-block"
                      @click="recPass"
                    >
                    <strong v-if="busy == false">Recuperar</strong>
                    <b-spinner small v-else class="align-items-center justify-content-center"/>
                    </b-button>
                    
                  </div>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <modal
      :mensaje = this.mensajeModal
      :error = this.errorModal
      v-show="error"
      @close="volver"
    />
  </Layout>
</template>

<style>
.vue-notification {
  margin-top: 15px;
}
.logo-back {
  background: #000000;
}
.header-back {
  background: #ff0000;
}
.text-header {
  color: #ffffff;
}
.btnVolver, .btnVolver:active {
  color: #fff;
  margin-top: 1rem;
  font-size: medium;
  font-style: italic;
}
.btnVolver:hover {
  color: #555;
}
</style>
